import setDeviceInfo from './set-device-info'
import setCmpConsentData from './set-cmp-consent-data'
import setWindowDimensions from './set-window-dimensions'

export default function(ctx) {
  setCmpConsentData(ctx)
  setDeviceInfo(ctx)
  setWindowDimensions(ctx)
}
